import type { State } from '../../types';

export const weekStart = (state: State): string => state.weekStart;
